//const serverUrl = "https://zilla-dev-server-2sjfz.ondigitalocean.app";

const serverUrl = "https://zilla-prod-server.eassist.me";
// const serverUrl = "http://localhost:8080";

export default serverUrl;
